import { useChatbot } from './useChatbot.js';
import { useQueryResourceDetail } from '../../resources/queries/useQueryResourceDetail.js';
import { useResourceLoadingStateIndicatorProps } from '../../resources/components/StateSpinner.js';
import { AssistantEphemeralContextType } from '../types.js';

const useActiveContextFileProcessing = () => {
  const { ephemeralContext: activeContext } = useChatbot();
  const { data: resource } = useQueryResourceDetail({
    resourceId: activeContext?.type === AssistantEphemeralContextType.Resource ? activeContext.value : void 0
  });
  const { isIndexing: showProcessingIndicator } = useResourceLoadingStateIndicatorProps(resource);
  return showProcessingIndicator && activeContext?.type === AssistantEphemeralContextType.Resource;
};

export { useActiveContextFileProcessing };
//# sourceMappingURL=useActiveContextFileProcessing.js.map
